// pages/FormViewerPage/layoutClasses.ts — index.tsx split (sub-module computed classes)
import type { Form } from '../../types';

export function computeLayoutClasses(form: Form) {
    // 2026-10-30: Jarak Antar Blok dihapus (setting tak tersimpan — tanpa kolom DB;
    // diklik + simpan = save error). Render dikunci 'normal' (mb-6, sama spt default lama).
    const blockSpacingClass = 'mb-6';
    const shippingKeys = Object.keys(form.shippingSettings ?? {}) as Array<keyof typeof form.shippingSettings>;
    const alignMap: Record<string, string> = { left: 'text-left', center: 'text-center', right: 'text-right' };
    const descriptionClasses = 'text-slate-600 dark:text-slate-300 mb-4 text-sm whitespace-pre-wrap ' + (alignMap[form.descriptionAlign] || 'text-left');
    return { blockSpacingClass, shippingKeys, descriptionClasses };
}
